"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeMessageStatus = void 0;
var utils_1 = require("./utils");
var BridgeMessageStatus = /** @class */ (function () {
    function BridgeMessageStatus() {
    }
    BridgeMessageStatus.isWaitingForConnect = function (bridgeMsgType, parsedBridgeMsg) {
        return (parsedBridgeMsg.connect_string != null && bridgeMsgType === 'access');
    };
    BridgeMessageStatus.isConnected = function (bridgeMsgType, parsedBridgeMsg) {
        return (parsedBridgeMsg.connect_id != null && parsedBridgeMsg.session_id != null && bridgeMsgType === 'access');
    };
    BridgeMessageStatus.isAccepted = function (bridgeMsgType, parsedBridgeMsg) {
        return (parsedBridgeMsg.message_type === 'ConnectionAcceptNotify' &&
            parsedBridgeMsg.user_status === 'UserAccepted' &&
            bridgeMsgType === 'proxy');
    };
    BridgeMessageStatus.isConnectRejected = function (bridgeMsgType, bridgeMsg) {
        return (bridgeMsg.message_type === 'ConnectionAcceptNotify' &&
            bridgeMsg.user_status === 'UserRejected' &&
            bridgeMsgType === 'proxy');
    };
    BridgeMessageStatus.isTransactionRejected = function (bridgeMsgType, bridgeMsg) {
        var _a;
        return ((0, utils_1.isTransferResponseMsg)(bridgeMsg.message_type) &&
            ((_a = bridgeMsg.data) === null || _a === void 0 ? void 0 : _a.tx_status) === "Rejected" &&
            bridgeMsgType === 'proxy');
    };
    BridgeMessageStatus.isRejected = function (bridgeMsgType, parsedBridgeMsg) {
        return BridgeMessageStatus.isConnectRejected(bridgeMsgType, parsedBridgeMsg) ||
            BridgeMessageStatus.isTransactionRejected(bridgeMsgType, parsedBridgeMsg);
    };
    BridgeMessageStatus.isAccountInfoResponse = function (bridgeMsgType, parsedBridgeMsg) {
        return (parsedBridgeMsg.message_type === 'AccountInfoResponse' &&
            bridgeMsgType === 'proxy');
    };
    BridgeMessageStatus.isSimpleTransferResponse = function (bridgeMsgType, bridgeMsg) {
        return (0, utils_1.isTransferResponseMsg)(bridgeMsg.message_type) && bridgeMsgType === 'proxy';
    };
    BridgeMessageStatus.isTransactionResponse = function (bridgeMsgType, bridgeMsg) {
        return (0, utils_1.isTransferResponseMsg)(bridgeMsg.message_type) && bridgeMsgType === 'proxy';
    };
    BridgeMessageStatus.isError = function (bridgeMsgType, parsedBridgeMsg) {
        return (parsedBridgeMsg.code === '500' &&
            bridgeMsgType === 'info');
    };
    return BridgeMessageStatus;
}());
exports.BridgeMessageStatus = BridgeMessageStatus;
